import { CreateAppointment } from '~/domain/usecases/appointment/redux';
import {
  iActionCreate,
  iActionCreateFailed,
  iActionCreateSuccess,
  AppointmentTypes,
} from '~/domain/interfaces/redux/appointment/create';

export const createRequest = (
  payload: CreateAppointment.Params,
): iActionCreate => ({
  type: AppointmentTypes.CREATE,
  payload,
});

export const createSuccess = (
  params: CreateAppointment.Model,
): iActionCreateSuccess => ({
  type: AppointmentTypes.CREATE_SUCCESS,
  payload: params,
});

export const createFailed = (): iActionCreateFailed => ({
  type: AppointmentTypes.CREATE_FAILED,
});
